var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"t-gray tac fz-24 mt-40"},[_c('p',[_vm._v("本服务由广州南方人才市场提供")]),_c('p',[_vm._v("广州参数信息科技有限公司提供技术支持")])])}]

export { render, staticRenderFns }